import axios from './_nestAxios'

// Consultar logic

export const obtenerAsTreeView = () => axios.get('/presupuestos', { params: { tipoConsulta: 'tree-view' } })

export const obtenerAsNivel1Select = () => axios.get('/presupuestos', { params: { tipoConsulta: 'nivel1-select' } })

export const obtenerAsNivel3Select2 = ({ busqueda }) =>
  axios.get('/presupuestos', { params: { tipoConsulta: 'nivel3-select2', busqueda } })

export const obtenerxDatoNivel1AsInfoAsignacionPresupuesto = datoPresupuestoNivel1 =>
  axios.get('/presupuestos', { params: { tipoConsulta: 'info-asignacion-presupuesto', datoPresupuestoNivel1 } })

// Insertar logic

export const nuevo = data => axios.post('/presupuestos', data)

// Eliminar logic

export const eliminarxId = id => axios.delete(`/presupuestos/${id}`)
